import { render, staticRenderFns } from "./member_card.vue?vue&type=template&id=54ba38f5&scoped=true"
import script from "./member_card.vue?vue&type=script&lang=js"
export * from "./member_card.vue?vue&type=script&lang=js"
import style0 from "./member_card.vue?vue&type=style&index=0&id=54ba38f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba38f5",
  null
  
)

export default component.exports